/**
 * This is the Title component. It accepts parameters like timestamp, title and style for title text.
 *
 * @module views/Atoms/Title
 * @memberof -Common
 */
import './Title.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Text from '@ulta/core/components/Text/Text';


/**
 * Represents a Title component
 *
 * @method
 * @param {TitleProps} props - React properties passed from composition
 * @returns Title
 */
export const Title = function( props ){

  const { htmlTag = defaultProps.htmlTag } = props;

  return (
    <div className='Title'>

      <div className='Title__wrapper'>
        <div className={ classNames( 'Title__contentSection', {
          [`Title__contentSection--${props.gridAlignment}`]: props.gridAlignment
        } )
        }
        >
          { props?.timestamp &&
            <div className='Title__date'>
              <Text
                color='neutral-600'
                htmlTag='p'
                textStyle='eyebrow'
              >
                { props.timestamp }
              </Text>
            </div>
          }
          { props?.title &&
            <div className='Title__header'>
              <Text
                htmlTag={ htmlTag }
                textStyle={ props.textStyle }
              >
                { props.title }
              </Text>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

/**
  * Property type definitions
  * @typedef TitleProps
  * @type {object}
  * @property {string} timestamp - Sets the timestamp value
  * @property {string} title - Sets the title value
  * @property {string} gridAlignment - Sets the alignment to grid
  * @property {string} htmlTag - Sets the HTML tag for the container
  * @property {string} textStyle - Sets the title styling
  */

export const propTypes = {
  /** Sets the timestamp for display */
  timestamp: PropTypes.string,
  /** Sets the title for display */
  title: PropTypes.string,
  /** Sets the alignment to grid */
  gridAlignment: PropTypes.string,
  /** Sets the HTML tag for the container */
  htmlTag: PropTypes.oneOf( [
    'p',
    'P',
    'span',
    'SPAN',
    'h1',
    'H1',
    'h2',
    'H2',
    'h3',
    'H3',
    'h4',
    'H4',
    'h5',
    'H5',
    'h6',
    'H6'
  ] ),
  /** Sets the style for display */
  textStyle: PropTypes.string
};

/**
 * Default values for passed properties
 * @type {object}
 * @property {string} [htmlTag='h1'] - The default HTML tag for the container
 */
export const defaultProps = {
  htmlTag: 'h1'
};

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
